import '@fontsource-variable/albert-sans'
import '@fontsource/kalam/700.css'
import '@/styles/main.css'
import Alpine from 'alpinejs'
import resize from '@alpinejs/resize'
import intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'
import tooltip from './components/tooltip'
import slider from './components/slider'
Alpine.plugin(resize)
Alpine.plugin(intersect)
Alpine.plugin(focus)
Alpine.data('tooltip', tooltip)
Alpine.data('slider', slider)
window.Alpine = Alpine
Alpine.start()
